module.exports = __webpack_public_path__ + "media/icons/pochodzenie-polska-white@3x-f296b69a.svg";